import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectSpaceInfo } from '../../selectors/ContentSelectors';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { ScheduleSpace, ScheduleSpaceDispatchProps, ScheduleSpaceStateProps } from './ScheduleSpace';

const mapStateToProps: MapStateToProps<ScheduleSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'schedule'>(state, 'schedule'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  displaySchedulesInClientTimezone: SessionServerSelectors.displaySchedulesInClientTimezone(state),
});

const mapDispatchToProps: MapDispatchToProps<ScheduleSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedScheduleSpace = connect(mapStateToProps, mapDispatchToProps)(ScheduleSpace);
